import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'utils/axios'; // Ensure axios is properly configured
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { Box, Button, Typography, Stack } from '@mui/material';


const CreateCodebook = () => {
  const [resolved, setResolved] = useState(null);
  const [valid, setValid] = useState(false);
  const [values, setValues] = useState({});
  const [activeWarning, setActiveWarning] = useState(false);
  const [next, setNext] = useState(null);
  const [forward, setForward] = useState(false);

  const { codebookType } = useParams();

  const navigate = useNavigate();

  const { t } = useTranslation();


  // Validation rules
  const rules = {
    required: [(v) => !!v || v === false || t('required_field')],
    requiredNumber: [(v) => (!!v || v == 0) && /^[0-9]*$/.test(v) || t('valid_number')],
  };

  // Fetch fields from API (useEffect is equivalent to Vue's mounted)
  useEffect(() => {
    const fetchFields = async () => {
      try {
        const response = await axios.get(`/codebook/${codebookType}/fields`);

        setResolved(response.data);
        const initialValues = {};
        response.data.forEach((field) => {
          initialValues[field.tableField] = null;
        });
        setValues(initialValues);
      } catch (error) {
        console.error('Failed to fetch fields:', error);
      }
    };

    fetchFields();
  }, [codebookType]);

  // Handle cancel action
  const cancel = () => {
    navigate(`/codebook/${codebookType}`);

  };

  // Handle response from the confirmation modal
  const response = (response) => {
    if (response) {
      next();
    } else {
      next(false);
      setActiveWarning(false);
    }
  };

  // // Before leaving the page, warn the user if changes aren't saved
  // useEffect(() => {
  //   const handleBeforeUnload = (event) => {
  //     if (!forward) {
  //       setActiveWarning(true);
  //       event.returnValue = 'Are you sure you want to leave without saving your changes?';
  //     }
  //   };

  //   window.addEventListener('beforeunload', handleBeforeUnload);
  //   return () => {
  //     window.removeEventListener('beforeunload', handleBeforeUnload);
  //   };
  // }, [forward]);

  // Submit handler
  const onSubmit = async () => {
    setValid(true);

    if (true) {
      try {
        await axios.post(`/codebook/${codebookType}`, { codebook: values });
        setForward(true);
        toast.success(t('successful_addition'));

        // navigate(`/home/codebook/${codebookType}`);
      } catch (error) {
      }
    }
  };

  // Render form fields dynamically
  const renderFields = () => {
    return resolved?.map((field) => {
      if (true) {
        return (
          <div key={field.tableField}>
            {field.type === 'select' && (
              <div>
                <label>{field.name}</label>
                <select
                  multiple={field.multiple}
                  value={values[field.tableField] || []}
                  onChange={(e) => {
                    const selectedValues = Array.from(e.target.selectedOptions, (option) => option.value);
                    setValues({ ...values, [field.tableField]: selectedValues });
                  }}
                >
                  {field.options.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>
            )}
            {field.type === 'checkbox' && (
              <div>
                <label>{field.name}</label>
                <input
                  type="checkbox"
                  checked={values[field.tableField] || false}
                  onChange={(e) => setValues({ ...values, [field.tableField]: e.target.checked })}
                />
              </div>
            )}
            {(field.type === 1 || field.type === 2) && (
              <div>
                <label>{field.name}</label>
                <input
                  type={field.type === 1 ? 'number' : 'text'}
                  value={values[field.tableField] || ''}
                  onChange={(e) => setValues({ ...values, [field.tableField]: e.target.value })}
                />
              </div>
            )}
          </div>
        );
      }
      return null;
    });
  };

  // Utility function to show field based on rights (you can customize this logic)
  const showField = (action, fieldRights) => {
    // Example check: only show field if the fieldRights are not restricted for 'add' action
    return true;
    return fieldRights === action || fieldRights === 'all';
  };

  return (
    <div>
      {resolved && (
  <Box
    sx={{
      p: 4,
      width: '100%',
      maxWidth: 900,         // same width as MUI version
      mx: 'auto',            // horizontally center
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
    }}
  >
    <Typography variant="h4" gutterBottom>
      {t(`${codebookType}`)}
    </Typography>

    <Box
      component="form"
      onSubmit={(e) => e.preventDefault()}
      sx={{ width: '100%' }}
    >
      <Stack spacing={3}>{renderFields()}</Stack>

      <Stack direction="row" spacing={2} mt={4} justifyContent="flex-end">
        <Button onClick={cancel}>
          {t('cancel')}
        </Button>
        <Button variant="contained" color="primary" onClick={onSubmit}>
          {t('add')}
        </Button>
      </Stack>
    </Box>
  </Box>
)}

    </div>
  );
};

export default CreateCodebook;
